<script setup>
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
</script>

<template>
  <div class="page-container-404 flex d-flex justify-content-center align-items-center bg-gray-100">
    <div class="text-center">
      <h1 class="text-4xl font-bold mb-6">{{ t('pageNotFound.page_not_found') }}</h1>
      <p class="text-gray-600 text-lg mb-8">{{ t('pageNotFound.page_looking_for_not_found') }}</p>
      <router-link to="/home" class="text-blue-500 hover:underline">{{ t('pageNotFound.go_to_home_page') }}</router-link>
    </div>
  </div>
</template>

<style scoped>
.page-container-404 {
  min-height: calc(100vh - 56px);
}
</style>
